module.exports = __webpack_public_path__ + "static/media/KF-Logo.96392c0d.svg";